/* eslint-disable @typescript-eslint/no-namespace */
import type { Utility } from '../../types/utility';

export namespace Wave {
  /** Wave Component Variant Keys */
  export type VariantKeys = 'default';

  /** Wave Component Variants */
  export type Variants = {
    [Key in VariantKeys]: Utility.CSSProperties;
  };

  /** Wave Component Variant Modes */
  export type VariantModes = Utility.VariantKeyModes<VariantKeys>;
}

const baseWave: Utility.VariantCSSKeys<Wave.VariantKeys> = {
  default: {
    '& > .waveChildrenContainer': {
      backgroundColor: 'primary',
      paddingTop: 's32',
      paddingBottom: 's32',
      width: '100%',
      color: 'white',
    },
  },
};

const wave: Utility.VariantKeyModes<Wave.VariantKeys> = {
  products: {
    chart: baseWave,
    chartblog: baseWave,
    co: baseWave,
    edu: baseWave,
    scale: baseWave,
    spark: baseWave,
  },
};

export const waveVariants = Object.keys(baseWave) as Wave.VariantKeys[];

export default wave;
